import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {VeicoloData} from "@/interface/VeicoloData";

interface CartState {
    vehicles: VeicoloData[];
}

// Funzione per caricare il carrello dal localStorage
const loadCartFromLocalStorage = (): CartState => {
    try {
        if (typeof window !== "undefined") {
            const serializedCart = localStorage.getItem('cart');
            if (serializedCart) {
                return JSON.parse(serializedCart);
            }
        }
        return { vehicles: [] };
    } catch (e) {
        console.error("Errore durante il caricamento del carrello dal localStorage", e);
        return { vehicles: [] };
    }
};

// Funzione per salvare il carrello nel localStorage
const saveCartToLocalStorage = (state: CartState) => {
    try {
        if (typeof window !== "undefined") {
            const serializedCart = JSON.stringify(state);
            localStorage.setItem('cart', serializedCart);
            window.dispatchEvent(new CustomEvent('cart-updated', { detail: state.vehicles }));
        }
    } catch (e) {
        console.error("Errore durante il salvataggio del carrello nel localStorage", e);
    }
};


const initialState: CartState = loadCartFromLocalStorage();

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addVehicleToCart: (state, action: PayloadAction<VeicoloData>) => {
            console.log("addVehicleToCart:", action.payload);
            console.log("state:", state);
            const exists = state.vehicles.find(vehicle => vehicle.articolo === action.payload.articolo);
            if (!exists) {
                state.vehicles.push(action.payload);
                saveCartToLocalStorage(state);
            }
        },
        removeVehicleFromCart: (state, action: PayloadAction<string>) => {
            state.vehicles = state.vehicles.filter(vehicle => vehicle.articolo !== action.payload);
            saveCartToLocalStorage(state);
        },
        clearCart: state => {
            state.vehicles = [];
            saveCartToLocalStorage(state);
        }
    },
});

export const { addVehicleToCart, removeVehicleFromCart, clearCart } = cartSlice.actions;

export default cartSlice.reducer;
